<template>
  <div>
    <FrontEndHeader></FrontEndHeader>
    <div class="wrapper">
      <div class="text-center mt-4 name" :style="{ color: getThemeColor }">
        {{ getUserCompany.name }}
      </div>
      <div class="p-3 mt-3">
        <div class="form-field d-flex align-items-center">
          <!-- <span class="fa fa-user"></span> -->
          <v-icon>mdi-account</v-icon>
          <input v-model="name" type="text" placeholder="Full Names" />
        </div>
        <div class="form-field d-flex align-items-center">
          <!-- <span class="fa fa-user"></span> -->
          <v-icon>mdi-phone</v-icon>
          <input v-model="tel" type="text" placeholder="Phone Number" />
        </div>
        <div class="form-field d-flex align-items-center">
          <!-- <span class="fa fa-user"></span> -->
          <v-icon>mdi-email</v-icon>
          <input v-model="email" type="email" placeholder="Email" />
        </div>
        <div class="form-field d-flex align-items-center">
          <!-- <span class="fas fa-key"></span> -->
          <v-icon>mdi-account-lock</v-icon>
          <input
            v-model="password"
            type="password"
            id="password"
            placeholder="Password"
          />
        </div>
        <div class="d-flex align-items-center">
          <input type="checkbox" @click="showPassword()" /><label
            :style="{ color: getThemeColor }"
            @click="showPassword()"
            >&nbsp;&nbsp;Show Password</label
          >
        </div>

        <v-btn
          align="right"
          small
          class="btn mt-3"
          :color="getThemeColor"
          dark
          @click.prevent="register()"
          rounded
          >Register</v-btn
        >
      </div>
      <div class="text-center fs-6 mt-4">
        <v-btn
          small
          rounded
          color="#0077DD"
          dark
          @click.prevent="$router.push('login')"
          class="mt-n2"
          ><v-icon x-small>mdi-account</v-icon>OR Login</v-btn
        >
      </div>
    </div>
    <WebsiteFooter></WebsiteFooter>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import FrontEndHeader from "./FrontEndHeader.vue";
import { mapGetters } from "vuex";
import WebsiteFooter from "@/components/SchoolWebsite/WebsiteFooter.vue";
export default {
  computed: mapGetters(["getThemeColor", "getUserCompany", "getAccessToken"]),
  components: { FrontEndHeader, WebsiteFooter },
  mounted() {
    if (
      this.$route.query.token != undefined &&
      this.$route.query.token != null
    ) {
      this.token = this.$route.query.token;
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/get-invited-user",
          { token: this.token },
          this.getAccessToken
        )
        .then((invitedUser) => {
          this.$store.commit("setLoader", false);
          this.name = invitedUser.name;
          this.email = invitedUser.email;
          this.tel = invitedUser.phone;
          this.alevel = invitedUser.alevel;
          this.sid = invitedUser.sid;
          this.emis = invitedUser.emis;
        });
    }
  },
  data() {
    return {
      emis: null,
      sid: null,
      alevel: null,
      token: null,
      name: null,
      email: null,
      tel: null,
      password: null,
    };
  },

  methods: {
    showPassword() {
      const passwordInput = document.getElementById("password");
      if (passwordInput.type === "password") {
        passwordInput.type = "text";
      } else {
        passwordInput.type = "password";
      }
    },
    register() {
      if (
        this.name == null ||
        this.email == null ||
        this.tel == null ||
        this.password == null
      ) {
        this.$toast.error("All Fields Are Required!", { duration: 5000 });
      } else {
        let axiosPromise = "";
        if (this.token != null) {
          axiosPromise = axios.postData("/auth/register-invited-user", {
            name: this.name,
            sid: this.sid,
            alevel: this.alevel,
            token: this.token,
            email: this.email,
            tel: this.tel,
            password: this.password,
            emis: this.emis,
          });
        } else {
          axiosPromise = axios.postData("/auth/register", {
            name: this.name,
            email: this.email,
            tel: this.tel,
            password: this.password,
            emis: this.getUserCompany.emis,
          });
        }
        axiosPromise.then((response) => {
          this.$router.push({ name: "login" });
        });
      }
    }, //end of login method
  },
};
</script>

<style scoped>
/* Importing fonts from Google */
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap");

/* Reseting */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Poppins", sans-serif;
}

body {
  background: #ecf0f3;
}

.wrapper {
  max-width: 350px;
  min-height: 500px;
  margin: 130px auto;
  padding: 40px 30px 30px 30px;
  background-color: #ecf0f3;
  border-radius: 15px;
  box-shadow: 13px 13px 20px, -13px -13px 20px;
}

.logo {
  width: 80px;
  margin: auto;
}

.logo img {
  width: 100%;
  height: 80px;
  object-fit: cover;
  border-radius: 50%;
  box-shadow: 0px 0px 3px #5f5f5f, 0px 0px 0px 5px #ecf0f3, 8px 8px 15px #a7aaa7,
    -8px -8px 15px #fff;
}

.wrapper .name {
  font-weight: 600;
  font-size: 1.4rem;
  letter-spacing: 1.3px;
  padding-left: 10px;
  color: #555;
}

.wrapper .form-field input {
  width: 100%;
  display: block;
  border: none;
  outline: none;
  background: none;
  font-size: 1.2rem;
  color: #666;
  padding: 10px 15px 10px 10px;
  /* border: 1px solid red; */
}

.wrapper .form-field {
  padding-left: 10px;
  margin-bottom: 20px;
  border-radius: 20px;
  box-shadow: inset 8px 8px 8px #cbced1, inset -8px -8px 8px #fff;
}

.wrapper .form-field .fas {
  color: #555;
}

.wrapper .btn {
  box-shadow: none;
  width: 100%;
  height: 40px;
  background-color: #03a9f4;
  color: #fff;
  border-radius: 25px;
  box-shadow: 3px 3px 3px #b1b1b1, -3px -3px 3px #fff;
  letter-spacing: 1.3px;
}

.wrapper .btn:hover {
  background-color: #039be5;
}

.wrapper a {
  text-decoration: none;
  font-size: 0.8rem;
  color: #03a9f4;
}

.wrapper a:hover {
  color: #039be5;
}

@media (max-width: 380px) {
  .wrapper {
    margin: 30px 20px;
    padding: 40px 15px 15px 15px;
  }
}
</style>
